/**
 * Calculate the number of business days between two dates.
 * Business days exclude weekends (Saturday and Sunday).
 * This is a client-safe replacement for moment-business-days.
 */
export function businessDaysDiff(startDate: Date, endDate: Date): number {
  const start = new Date(startDate)
  const end = new Date(endDate)

  // Normalize to start of day
  start.setHours(0, 0, 0, 0)
  end.setHours(0, 0, 0, 0)

  let count = 0
  const current = new Date(start)

  // Determine direction
  const direction = end >= start ? 1 : -1

  while ((direction === 1 && current < end) || (direction === -1 && current > end)) {
    const dayOfWeek = current.getDay()
    // 0 = Sunday, 6 = Saturday
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      count += direction
    }
    current.setDate(current.getDate() + direction)
  }

  return count
}
